import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from './ImageCard.css';

const ImageCard = props => {
  const { item, className, sectionName } = props;
  const classes = classNames(css.root, 'imageCard', className, css.clickable);

  const getImageUrl = (item) => {
    const basePath = 'https://cloudfront.gloset.mx/images/home';
    const itemName = item.name;

    return `${basePath}/${sectionName}/${itemName}.webp`;
  };

  const handleClick = () => {
    window.location.href = item.url;
  };

  return (
    <div 
      className={classes}
      onClick={handleClick}
    >
      <div className={css.imageWrapper}>
        <div className={css.aspectWrapper}>
          <img 
            className={css.image} 
            src={getImageUrl(item)}
            alt={item.title}
            draggable="false"
          />
        </div>
      </div>
      <div className={css.info}>
        <div className={css.title}>{item.title}</div>
      </div>
    </div>
  );
};

ImageCard.defaultProps = {
  className: null,
};

ImageCard.propTypes = {
  item: PropTypes.shape({
    title: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
  className: PropTypes.string,
  sectionName: PropTypes.string.isRequired,
};

export default ImageCard; 